import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
	providedIn: 'root'
})
export class KcAdminGuard extends KeycloakAuthGuard implements CanActivate {
	constructor(
		protected override readonly router: Router,
		protected readonly keycloak: KeycloakService
	) {
		super(router, keycloak);
	}

	allowedGroup = 'admin';

	isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
		return Promise.resolve(this.keycloak.isUserInRole(this.allowedGroup));
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
		return this.isAccessAllowed(route, state);
	}
}
